import { ActivationEnd, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    tap,
    withLatestFrom,
    map,
    distinctUntilChanged,
    mapTo,
    filter,
} from 'rxjs/operators';

import {
    SettingsActionTypes,
    SettingsActions,
    ActionSettingsChangeHour
} from './settings.actions';
import {
    selectEffectiveTheme,
    selectSettingsState
} from './settings.selectors';
import { State } from './settings.model';
import { LocalStorageService } from '../../core/local-storage/local-storage.service';
import { AnimationsService } from '../../core/animations/animations.service';
import { interval, of, merge } from 'rxjs';

export const SETTINGS_KEY = 'SETTINGS';

const INIT = of('anms-init-effect-trigger');

@Injectable()
export class SettingsEffects {
    constructor(
        private actions$: Actions<SettingsActions>,
        private store: Store<State>,
        private router: Router,
        private overlayContainer: OverlayContainer,
        private localStorageService: LocalStorageService,
        private animationsService: AnimationsService
    ) {
    }

    // interval holds up angular from getting ready in protractor selenium
    // @Effect()
    // changeHour = interval(60000).pipe(
    //   mapTo(new Date().getHours()),
    //   distinctUntilChanged(),
    //   map(hour => new ActionSettingsChangeHour({ hour }))
    // );


    persistSettings = createEffect(() => this.actions$.pipe(
        ofType(
            SettingsActionTypes.CHANGE_ANIMATIONS_ELEMENTS,
            SettingsActionTypes.CHANGE_ANIMATIONS_PAGE,
            SettingsActionTypes.CHANGE_ANIMATIONS_PAGE_DISABLED,
            SettingsActionTypes.CHANGE_AUTO_NIGHT_AUTO_MODE,
            SettingsActionTypes.CHANGE_LANGUAGE,
            SettingsActionTypes.CHANGE_STICKY_HEADER,
            SettingsActionTypes.CHANGE_THEME
        ),
        withLatestFrom(this.store.select(selectSettingsState)),
        tap(([action, settings]) =>
            this.localStorageService.setItem(SETTINGS_KEY, settings)
        )
    ), { dispatch: false });


    updateRouteAnimationType = createEffect(() => merge(
        INIT,
        this.actions$.pipe(
            ofType(
                SettingsActionTypes.CHANGE_ANIMATIONS_ELEMENTS,
                SettingsActionTypes.CHANGE_ANIMATIONS_PAGE
            )
        )
    ).pipe(
        withLatestFrom(this.store.select(selectSettingsState)),
        tap(([action, settings]) =>
            this.animationsService.updateRouteAnimationType(
                settings.pageAnimations,
                settings.elementsAnimations
            )
        )
    ), { dispatch: false });


    updateTheme = createEffect(() => merge(
        INIT,
        this.actions$.pipe(ofType(SettingsActionTypes.CHANGE_THEME))
    ).pipe(
        withLatestFrom(this.store.select(selectEffectiveTheme)),
        tap(([action, effectiveTheme]) => {
            const classList = this.overlayContainer.getContainerElement().classList;
            const toRemove = Array.from(classList).filter((item: string) =>
                item.includes('-theme')
            );
            if (toRemove.length) {
                classList.remove(...toRemove);
            }
            classList.add(effectiveTheme);
        })
    ), { dispatch: false });

}
